import RulesSearch from './RulesSearch';

export { RulesSearch };
export default RulesSearch;
